import { useMenuLateralRecolhido } from '_metronic/layout/core'
import { PrescricaoCreate } from './PrescricaoCreate'

export const PrescricaoWrapper = () => {
  // A montagem precisa de largura: o menu lateral recolhe enquanto o médico prescreve.
  useMenuLateralRecolhido()
  return <PrescricaoCreate />
}
